import script from "./Translators.vue?vue&type=script&setup=true&lang=js"
export * from "./Translators.vue?vue&type=script&setup=true&lang=js"

import "./Translators.vue?vue&type=style&index=0&id=594f8e82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-594f8e82"]])

export default __exports__